import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntDatepickerComponent} from "./int-datepicker.component";

import {IntLabeledFieldBoxModule} from "../../boxes";
import {ReactiveFormsModule} from "@angular/forms";
import {IntCalendarModule} from "../../calendars";
import {IntPortalSlotModule} from "../../../modules";
import {IntNativeElementModule} from "../../../directives";
import {IntDropdownAreaModule} from "../../dropdowns";
import {IntClearActionDefaultModule} from "../../chanks";

@NgModule({
  imports: [
    CommonModule,
    IntCalendarModule,
    IntLabeledFieldBoxModule,
    ReactiveFormsModule,
    IntPortalSlotModule,
    IntNativeElementModule,
    IntDropdownAreaModule,
    IntClearActionDefaultModule
  ],
  declarations: [
    IntDatepickerComponent
  ],
  exports: [
    IntDatepickerComponent
  ]
})
export class IntDatepickerModule {}
